import React, { useCallback, useState } from "react";
import {
  bool,
  func,
  number,
  oneOf,
  oneOfType,
  shape,
  string
} from "prop-types";

import {
  contactPreferences as defaultContactPreferences,
  notes as defaultNotes
} from "../../constants/defaultFormValues";
import ENTITY_TYPES from "../../constants/entityTypes";
import INQUIRY_TYPES from "../../constants/inquiryTypes";
import VIEW_TYPES from "../../constants/viewTypes";
import useSellerInquirySubmitHandler from "../../hooks/useSellerInquirySubmitHandler";
import InterestedSellerModal from "../InterestedSellerModal";

const ControlledSellerInquiry = ({
  createInterestedSellerInquiry,
  entityId,
  entityType,
  handleRequestClose,
  inquiryType,
  isOpen,
  rootElementId,
  userContactDetails
}) => {
  const [view, updateView] = useState(VIEW_TYPES.form);

  const handleFormSubmit = useSellerInquirySubmitHandler({
    createInterestedSellerInquiry,
    entityId,
    entityType,
    inquiryType,
    updateView
  });

  const handleClose = useCallback(() => {
    updateView(VIEW_TYPES.form);
    handleRequestClose();
  });

  return (
    <InterestedSellerModal
      entityType={entityType}
      handleFormSubmit={handleFormSubmit}
      handleRequestClose={handleClose}
      initialFormValues={{
        ...userContactDetails,
        notes: defaultNotes,
        contact_preferences: defaultContactPreferences
      }}
      inquiryType={inquiryType}
      isOpen={isOpen}
      rootElementId={rootElementId}
      view={view}
    />
  );
};

ControlledSellerInquiry.defaultProps = {
  entityId: null,
  entityType: null
};

ControlledSellerInquiry.propTypes = {
  createInterestedSellerInquiry: func.isRequired,
  entityId: oneOfType([number, string]),
  entityType: oneOf(Object.values(ENTITY_TYPES)),
  handleRequestClose: func.isRequired,
  inquiryType: oneOf(Object.values(INQUIRY_TYPES)).isRequired,
  isOpen: bool.isRequired,
  rootElementId: string.isRequired,
  userContactDetails: shape({
    name: string.isRequired,
    email: string.isRequired,
    phone_number: string.isRequired
  }).isRequired
};

export default ControlledSellerInquiry;
